var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"click-more"},[(_vm.btnHide)?_c('div',[_vm._v("没有更多资料")]):_c('el-button',{attrs:{"round":"","size":"small"},on:{"click":_vm.showMore}},[_vm._v("显示更多")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }